import React, { useCallback, useEffect, useState } from 'react';
import cogoToast from 'cogo-toast';

import {
  findLessonByLessonType,
  useDeleteLessonMutation,
  useGetAcademyTopicQuery,
} from 'features/classCreation';
import CreateLessonModal from '../CreateLessonModal';
import ToggleChip from 'components/ToggleChip';

export default function LessonChip({ academyTopicId, lessonType, title }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteLesson, { isSuccess, error }] = useDeleteLessonMutation();

  const { lesson } = useGetAcademyTopicQuery(academyTopicId, {
    selectFromResult: ({ data }) => ({
      lesson: findLessonByLessonType({
        lessons: data?.data?.lessons,
        lessonType,
      }),
    }),
  });

  const handleModalOpen = useCallback(() => {
    setModalOpen(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Lesson is successfully deleted!');
    }
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in deleting the lesson. Please try again later!'
      );
    }
  }, [error, isSuccess]);

  const handleLessonDelete = useCallback(() => {
    if (window.confirm('Are you sure, you want to delete this lesson?')) {
      deleteLesson({ lessonId: lesson?.id, academyTopicId });
    }
  }, [academyTopicId, deleteLesson, lesson]);

  return (
    <>
      <CreateLessonModal
        title={title}
        handleClose={handleModalClose}
        lessonType={lessonType}
        isOpen={modalOpen}
        academyTopicId={academyTopicId}
      />
      <ToggleChip
        isAdded={Boolean(lesson)}
        onAdd={handleModalOpen}
        onRemove={handleLessonDelete}
        label={title}
        className="m-r-xs m-b-xxs"
      />
    </>
  );
}
